import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-light" data-id="element-68">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center" data-id="element-70">
          <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mb-6" data-id="element-71">
            <ShieldCheckIcon className="w-10 h-10 text-primary" data-id="element-72" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-text mb-4" data-id="element-73">
            Primero ves tu web, luego decides
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-74">
            Antes de contratar te mostramos cómo podría verse tu web. Así puedes
            ver exactamente cómo quedará la presencia online de tu negocio.
            <span className="font-semibold text-text block mt-2" data-id="element-75">
              Sin compromiso.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}